import React from 'react';
import { useSelector } from 'react-redux';
import range from 'lodash/range';

import WpSplitProgressBar from 'Wpds/components/progress/WpSplitProgressBar';

import { OnboardingWizardStep } from '../../../../types';

function getCurrentStepNumber(step, flowType) {
  switch (step) {
    case OnboardingWizardStep.profile:
      return 1;
    case OnboardingWizardStep.connectCalendar:
      return 2;
    case OnboardingWizardStep.workspaces: {
      if (flowType === 'mobile_calendar_integration') return 3;
      return 2;
    }
    case OnboardingWizardStep.oneOnOneWorkspacesFromCalendar: {
      return 3;
    }
    case OnboardingWizardStep.groupWorkspacesFromCalendar: {
      return 4;
    }
    case OnboardingWizardStep.inviteTeammates: {
      return 4;
    }
    case OnboardingWizardStep.discussionTopics:
      if (flowType === 'mobile_calendar_integration') return 5;
      return 3;
    default:
      return 4;
  }
}

function StepsSection() {
  const flowType = useSelector(state => state.onboardingState.flowType);
  const step: OnboardingWizardStep = useSelector(state => state.onboardingState.step);
  const numSteps: number = useSelector(state => state.onboardingState.numSteps);

  const steps = range(1, numSteps + 1).map(stepNumber => ({ stepNumber }));

  const currentNumberStep = getCurrentStepNumber(step, flowType);

  return <WpSplitProgressBar size="md" currentNumberStep={currentNumberStep} steps={steps} />;
}

export default StepsSection;
